<div class="page">

    <div class="header">
        <div class="header-container">
            <div class="header-branding">
                <img src="./assets/images/dhl-logo.svg" alt="DHL Logo">
            </div>
            <div class="header-branding dhl-express">DHL Express</div>
        </div>
        <ng-container *ngIf="(language$ | async)?.getCode() as locale">
            <div class="search-box" *ngIf="isAuthenticated && isDddUser && !isLoading">
                <app-search [locale]="locale"></app-search>
            </div>
            <div class="profile" *ngIf="isAuthenticated">
                <span>{{ userName }}<i class="fa fa-chevron-down margin-left-1" aria-hidden="true"></i></span>
                <div class="profile-menu">
                    <div class="profile-menu-item" *ngIf="(languages?.length ?? 0) > 1">
                        <app-language-selector [languages]="languages" [locale]="locale"
                            (onLanguageChanged)="onLanguageChanged($event)"></app-language-selector>
                    </div>
                    <div *ngIf="!isLoading">
                        <a class="profile-menu-item" routerLink="/help">
                            {{ 'M1' | translate : locale }}
                        </a>
                        <a class="profile-menu-item" (click)="onLogout()" *ngIf="isDddUser">
                            {{ 'M2' | translate : locale }}
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <main class="main">
        <router-outlet></router-outlet>
    </main>

</div>